import { useEffect, useState } from "react";
import { Building2, Plus, CheckCircle2, Handshake, Euro } from "lucide-react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function Marketplace() {
  const [tab, setTab] = useState("partners");
  const [partners, setPartners] = useState([]);
  const [subRentals, setSubRentals] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ company_name: "", vat_number: "", contact_email: "", contact_phone: "", location: "", partner_type: "hotel", commission_rate: 0.10 });

  const load = async () => {
    try {
      const [p, s] = await Promise.all([
        api.get("/marketplace/partners"),
        api.get("/marketplace/sub-rentals"),
      ]);
      setPartners(p.data?.items || []);
      setSubRentals(s.data?.items || []);
    } catch (e) { /* silent */ }
  };
  useEffect(() => { load(); }, []);

  const createPartner = async () => {
    try {
      await api.post("/marketplace/partners", { ...form, commission_rate: parseFloat(form.commission_rate) });
      toast.success("Partner creato (in attesa verifica)");
      setShowForm(false);
      setForm({ company_name: "", vat_number: "", contact_email: "", contact_phone: "", location: "", partner_type: "hotel", commission_rate: 0.10 });
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Errore"); }
  };

  const verify = async (id) => {
    try { await api.post(`/marketplace/partners/${id}/verify`); toast.success("Partner verificato"); load(); }
    catch (e) { toast.error("Solo super_admin"); }
  };

  return (
    <div className="space-y-6" data-testid="marketplace-page">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-display text-2xl sm:text-3xl font-black uppercase tracking-tight flex items-center gap-3">
            B2B Marketplace <Handshake className="text-[#ff0033]" />
          </h1>
          <p className="text-sm text-white/45 mt-1">Sub-noleggio flotta tra partner verificati · fatturazione B2B</p>
        </div>
        <button data-testid="partner-add" onClick={() => setShowForm(true)} className="btn-neon px-5 py-2 rounded-full text-xs inline-flex items-center gap-2">
          <Plus size={14}/> Nuovo Partner
        </button>
      </div>

      <div className="flex gap-2">
        {[
          { id: "partners", label: `Partners (${partners.length})` },
          { id: "sub-rentals", label: `Sub-Noleggi (${subRentals.length})` },
        ].map((t) => (
          <button key={t.id} data-testid={`mp-tab-${t.id}`} onClick={() => setTab(t.id)} className={`px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-[10px] sm:text-xs uppercase tracking-widest ${tab === t.id ? "bg-[#ff0033] text-white" : "bg-white/5 text-white/60"}`}>{t.label}</button>
        ))}
      </div>

      {showForm && (
        <div className="bg-white/[0.02] border border-[#ff0033]/40 rounded-2xl p-5 space-y-3">
          <div className="grid md:grid-cols-2 gap-3">
            <input data-testid="p-name" placeholder="Ragione sociale" value={form.company_name} onChange={(e)=>setForm({...form, company_name: e.target.value})} className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm" />
            <input data-testid="p-vat" placeholder="P.IVA" value={form.vat_number} onChange={(e)=>setForm({...form, vat_number: e.target.value})} className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm" />
            <input data-testid="p-email" placeholder="Email contatto" value={form.contact_email} onChange={(e)=>setForm({...form, contact_email: e.target.value})} className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm" />
            <input data-testid="p-phone" placeholder="Telefono" value={form.contact_phone} onChange={(e)=>setForm({...form, contact_phone: e.target.value})} className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm" />
            <input data-testid="p-loc" placeholder="Località" value={form.location} onChange={(e)=>setForm({...form, location: e.target.value})} className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm" />
            <select value={form.partner_type} onChange={(e)=>setForm({...form, partner_type: e.target.value})} className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm">
              <option value="hotel">🏨 Hotel</option>
              <option value="bb">🏠 B&B</option>
              <option value="agency">🧳 Agenzia viaggio</option>
              <option value="property_manager">🔑 Property Manager</option>
              <option value="rental_co">🚗 Co-Rental partner</option>
            </select>
            <input data-testid="p-rate" type="number" step="0.01" min="0" max="0.5" placeholder="Commissione (0.10 = 10%)" value={form.commission_rate} onChange={(e)=>setForm({...form, commission_rate: e.target.value})} className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm" />
          </div>
          <div className="flex gap-2">
            <button data-testid="p-submit" onClick={createPartner} className="btn-neon px-5 py-2 rounded-full text-xs">Crea</button>
            <button onClick={() => setShowForm(false)} className="px-5 py-2 rounded-full bg-white/5 border border-white/10 text-xs">Annulla</button>
          </div>
        </div>
      )}

      {tab === "partners" && (
        <div className="bg-white/[0.02] border border-white/10 rounded-2xl overflow-x-auto">
          <table className="w-full text-sm min-w-[640px]">
            <thead className="bg-black/40 text-white/60 text-[10px] uppercase tracking-widest">
              <tr><th className="text-left p-3">Azienda</th><th className="text-left p-3">P.IVA</th><th className="text-left p-3">Tipo</th><th className="text-left p-3">Commissione</th><th className="text-left p-3">Wallet</th><th className="text-left p-3">Stato</th></tr>
            </thead>
            <tbody>
              {partners.length === 0 && <tr><td colSpan={6} className="p-6 text-center text-white/40 text-xs">Nessun partner</td></tr>}
              {partners.map((p) => (
                <tr key={p.id} className="border-t border-white/5" data-testid={`partner-row-${p.id}`}>
                  <td className="p-3">
                    <div className="font-medium flex items-center gap-2"><Building2 size={12}/> {p.company_name}</div>
                    <div className="text-[10px] text-white/40">{p.contact_email} · {p.location || ""}</div>
                  </td>
                  <td className="p-3 font-mono text-xs">{p.vat_number}</td>
                  <td className="p-3 text-xs uppercase">{p.partner_type}</td>
                  <td className="p-3 font-mono">{(p.commission_rate * 100).toFixed(1)}%</td>
                  <td className="p-3 font-mono text-emerald-300">€{(p.wallet_balance || 0).toFixed(2)}</td>
                  <td className="p-3">
                    {p.verified ? (
                      <span className="text-emerald-300 text-[10px] inline-flex items-center gap-1"><CheckCircle2 size={11}/> VERIFICATO</span>
                    ) : (
                      <button data-testid={`p-verify-${p.id}`} onClick={() => verify(p.id)} className="text-[10px] px-2 py-0.5 rounded bg-amber-500/20 border border-amber-500/40 text-amber-300">Verifica</button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {tab === "sub-rentals" && (
        <div className="bg-white/[0.02] border border-white/10 rounded-2xl overflow-x-auto">
          <table className="w-full text-sm min-w-[640px]">
            <thead className="bg-black/40 text-white/60 text-[10px] uppercase tracking-widest">
              <tr><th className="text-left p-3">Data</th><th className="text-left p-3">Partner</th><th className="text-left p-3">Periodo</th><th className="text-right p-3">Importo</th><th className="text-right p-3">Commissione</th><th className="text-right p-3">Netto</th><th className="text-left p-3">Fattura</th></tr>
            </thead>
            <tbody>
              {subRentals.length === 0 && <tr><td colSpan={7} className="p-6 text-center text-white/40 text-xs">Nessun sub-noleggio</td></tr>}
              {subRentals.map((s) => (
                <tr key={s.id} className="border-t border-white/5">
                  <td className="p-3 text-[11px] text-white/60">{s.created_at?.slice(0,10)}</td>
                  <td className="p-3 text-xs">{s.partner_name}</td>
                  <td className="p-3 text-xs">{s.start_date?.slice(0,10)} → {s.end_date?.slice(0,10)}</td>
                  <td className="p-3 text-right font-mono">€{s.agreed_price?.toFixed(2)}</td>
                  <td className="p-3 text-right font-mono text-amber-300">€{s.commission?.toFixed(2)}</td>
                  <td className="p-3 text-right font-mono text-emerald-300">€{s.net_to_owner?.toFixed(2)}</td>
                  <td className="p-3 text-[10px] uppercase">{s.invoice_b2b_status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
